module.exports = __webpack_public_path__ + "img/ph_manange1.dcd5bae1.png";